/* Provador "Medidas e caimento". Dono: C2. Abre em SV.emit('fit:open', {handle?, trigger?}).
   Perfil via SV.fit (local; nada em URL). Tabelas: metafield custom.tabela_medidas (json). Nunca inventa medida. */
(function () {
  if (window.__svFitInit) return;
  window.__svFitInit = true;

  var PREF = { justo: { ease: 2, label: 'mais próximo ao corpo' }, certo: { ease: 5.5, label: 'equilibrado' }, solto: { ease: 10.5, label: 'soltinho' } };
  var REG = [['bust', 'Busto', /bust|busto|peito/], ['waist', 'Cintura', /cintura|waist/], ['hip', 'Quadril', /quadril|hip/]];
  var LIM = { bust: [60, 160], waist: [45, 160], hip: [60, 180] };
  var dlg, st = { handle: null, data: null, tab: 'usual', pref: 'certo', trigger: null, usual: null, feel: 0 };
  // ordem das grades da loja (PP..5XG, com variações XG/GG e S/M/L); tamanho desconhecido fica onde está
  var RANK = { PP: 0, XS: 0, P: 1, S: 1, M: 2, G: 3, L: 3, GG: 4, XG: 4, XL: 4, XGG: 5, XXG: 5, '2XG': 5, '2GX': 5, XXL: 5, XXXG: 6, '3XG': 6, '3X': 6, '4XG': 7, '5XG': 8 };
  var cache = {};

  function $(s, r) { return (r || dlg).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || dlg).querySelectorAll(s)); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function num(v) { var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? null : n; }
  function fmt(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }

  /* ---------- perfil ---------- */
  function getProfile() {
    var p = null;
    try { p = window.SV && SV.fit ? SV.fit.get() : JSON.parse(localStorage.getItem('sv:fit')); } catch (e) {}
    if (!p || typeof p !== 'object') return null;
    return { bust: num(p.bust), waist: num(p.waist), hip: num(p.hip), pref: PREF[p.pref] ? p.pref : 'certo' };
  }
  function complete(p) { return !!(p && p.bust && p.waist && p.hip); }
  function setProfile(p) {
    try { if (window.SV && SV.fit) SV.fit.set(p); else { localStorage.setItem('sv:fit', JSON.stringify(p)); document.dispatchEvent(new CustomEvent('sv:fit:change', { detail: { profile: p } })); } } catch (e) {}
  }
  function clearProfile() {
    try { if (window.SV && SV.fit) SV.fit.clear(); else { localStorage.removeItem('sv:fit'); document.dispatchEvent(new CustomEvent('sv:fit:change', { detail: { profile: null } })); } } catch (e) {}
  }

  /* ---------- análise ---------- */
  function parseCell(s) {
    var t = String(s == null ? '' : s).replace(/cm/gi, '').replace(/,/g, '.');
    var m = t.match(/(\d+(?:\.\d+)?)\s*(?:–|—|-|a|até)\s*(\d+(?:\.\d+)?)/i);
    if (m) return { lo: +m[1], hi: +m[2] };
    m = t.match(/(\d+(?:\.\d+)?)/);
    return m ? { v: +m[1] } : null;
  }
  function analyze(tab, p) {
    var cols = tab.cols || [], rows = tab.rows || [], regs = [];
    REG.forEach(function (r) {
      var idx = cols.findIndex(function (c) { return r[2].test(String(c).toLowerCase()); });
      if (idx > 0 && p[r[0]]) regs.push({ key: r[0], label: r[1], idx: idx });
    });
    if (!regs.length) return null;
    var cells = rows.map(function (row) { return { size: String(row[0]), c: regs.map(function (g) { return parseCell(row[g.idx]); }) }; });
    var anyRange = cells.some(function (r) { return r.c.some(function (x) { return x && x.lo != null; }); });
    var base = tab.base || (anyRange ? 'corpo' : 'peca');
    var target = PREF[p.pref].ease;
    function dist(x, g) {
      if (!x) return 99;
      if (base === 'corpo') { var lo = x.lo != null ? x.lo : x.v, hi = x.hi != null ? x.hi : x.v; return Math.max(lo - p[g.key], p[g.key] - hi, 0); }
      var v = x.v != null ? x.v : x.hi; return Math.abs(v - p[g.key] - target);
    }
    // Um tamanho só (Everton, 15/10/2026): o menor da grade que fecha em TODAS as regiões.
    // Corpo: a medida cabe até o limite de cima. Peça: a folga não fica mais justa que o gosto (alvo - 3 cm).
    function fits(x, g) {
      if (!x) return true; // célula vazia não reprova
      if (base === 'corpo') { var hi = x.hi != null ? x.hi : x.v; return p[g.key] <= hi; }
      var v = x.v != null ? x.v : x.hi; return v - p[g.key] >= target - 3;
    }
    var pickIdx = -1;
    for (var ci = 0; ci < cells.length && pickIdx < 0; ci++) {
      if (regs.every(function (g, k) { return fits(cells[ci].c[k], g); })) pickIdx = ci;
    }
    var noneFits = pickIdx < 0;
    if (noneFits) pickIdx = cells.length - 1;
    var best = { i: pickIdx, r: cells[pickIdx] }, scored = [best], row = best.r;
    // no tamanho de baixo, quais regiões ficariam justas (explica por que não é ele)
    var tightBelow = pickIdx > 0 ? regs.filter(function (g, k) { return !fits(cells[pickIdx - 1].c[k], g); }).map(function (g) { return g.label.toLowerCase(); }) : [];
    var regionSize = regs.map(function () { return row.size; });
    var conflict = false;
    var out = regs.map(function (g, k) {
      var x = row.c[k], d = dist(x, g), item = { label: g.label, value: p[g.key], state: 'in', text: '' };
      if (base === 'corpo') {
        var lo = x.lo != null ? x.lo : x.v, hi = x.hi != null ? x.hi : x.v;
        item.ref = lo === hi ? fmt(lo) + ' cm' : fmt(lo) + '–' + fmt(hi) + ' cm';
        if (p[g.key] > hi) { item.state = 'above'; item.text = fmt(p[g.key] - hi) + ' cm acima da referência: confirme o espaço nesta região.'; }
        else if (p[g.key] < lo) { item.state = 'below'; item.text = fmt(lo - p[g.key]) + ' cm abaixo da referência: pode haver mais espaço nesta região.'; }
        else item.text = 'Dentro da referência deste tamanho.';
      } else {
        var piece = x.v != null ? x.v : x.hi, ease = piece - p[g.key];
        item.ref = fmt(piece) + ' cm (peça)';
        item.text = 'Folga estimada de ' + fmt(ease) + ' cm (alvo para o seu gosto: cerca de ' + fmt(target) + ' cm).';
        if (ease < 0) { item.state = 'below'; item.text = 'A peça mede ' + fmt(-ease) + ' cm a menos que você nesta região: pode não fechar.'; }
        else if (ease < target - 3) { item.state = 'below'; item.text = 'Folga estimada de ' + fmt(ease) + ' cm: mais justa que o seu gosto.'; }
        else if (ease > target + 3) { item.state = 'above'; item.text = 'Folga estimada de ' + fmt(ease) + ' cm: mais solta que o seu gosto.'; }
      }
      return item;
    });
    var extreme = noneFits || (base === 'corpo' ? regs.some(function (g, k) { return dist(row.c[k], g) >= 8; }) : out.some(function (o) { return o.state === 'below' && /a menos/.test(o.text); }));
    var near = out.some(function (o) { return o.state !== 'in'; });
    var next = rows[scored[0].i + 1], prev = rows[scored[0].i - 1];
    return { name: tab.t || '', base: base, size: row.size, regions: out, conflict: conflict, extreme: extreme, near: near,
      regionSizes: regs.map(function (g, k) { return g.label + ': ' + regionSize[k]; }),
      tightBelow: tightBelow, below: pickIdx > 0 ? cells[pickIdx - 1].size : null,
      next: next ? String(next[0]) : null, prev: prev ? String(prev[0]) : null };
  }

  /* ---------- dados ---------- */
  function payloadFrom(root) {
    var j = root.querySelector('[data-sv-fit-json]');
    if (!j) return null;
    var d; try { d = JSON.parse(j.textContent); } catch (e) { return null; }
    var th = root.querySelector('[data-sv-fit-tables]');
    d.html = th ? th.innerHTML : '';
    d.tables = Array.isArray(d.tables) ? d.tables : [];
    return d;
  }
  function load(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var inDom = document.querySelector('[data-sv-fit-payload][data-handle="' + handle + '"]');
    if (inDom) { cache[handle] = payloadFrom(inDom); return Promise.resolve(cache[handle]); }
    var root = (dlg.dataset.routesRoot || '/').replace(/\/$/, '');
    return fetch(root + '/products/' + encodeURIComponent(handle) + '?section_id=sv-pdp-below-fit', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var n = doc.querySelector('[data-sv-fit-payload]');
        return (cache[handle] = n ? payloadFrom(n) : null);
      }).catch(function () { return null; });
  }

  /* ---------- UI ---------- */
  function waHref(title) {
    var c = window.SV && SV.config && SV.config.contact, base = (c && c.waLink) || (dlg.dataset.wa ? 'https://wa.me/' + dlg.dataset.wa : '');
    if (!base) return '';
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent('Olá! Quero ajuda com o caimento' + (title ? ' de ' + title : '') + '.');
  }
  function setTab(t) {
    st.tab = t;
    $$('[data-fit-tab]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.fitTab === t)); });
    $$('[data-fit-pane]').forEach(function (p) { p.hidden = p.dataset.fitPane !== t || !hasTables(); });
  }

  /* ---------- opção A: pelo tamanho que ela já usa ---------- */
  function grade() {
    var g = (st.data && st.data.sizes || []).filter(function (x) { return String(x).trim(); });
    var r = function (x) { var k = String(x).trim().toUpperCase(); return k in RANK ? RANK[k] : (isNaN(+k) ? null : +k); };
    return g.map(function (x, i) { return { s: String(x).trim(), r: r(x), i: i }; })
      .sort(function (a, b) { return a.r == null || b.r == null ? a.i - b.i : a.r - b.r || a.i - b.i; })
      .map(function (x) { return x.s; });
  }
  function usualSaved() { try { return JSON.parse(localStorage.getItem('sv:fit:usual')) || {}; } catch (e) { return {}; } }
  function renderUsual() {
    var g = grade(), box = $('[data-fit-usual]'), sv = usualSaved();
    st.usual = g.indexOf(sv.size) > -1 ? sv.size : null;
    st.feel = [-1, 0, 1].indexOf(sv.feel) > -1 ? sv.feel : 0;
    box.textContent = '';
    g.forEach(function (x) { var b = el('button', '', x); b.type = 'button'; b.dataset.usual = x; box.appendChild(b); });
    usualUI();
  }
  function usualUI() {
    $$('[data-usual]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.usual === st.usual)); });
    $$('[data-feel]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.feel === st.feel)); });
    var res = $('[data-fit-usual-res]'); res.textContent = '';
    if (!st.usual) { res.hidden = true; return; }
    try { localStorage.setItem('sv:fit:usual', JSON.stringify({ size: st.usual, feel: st.feel })); } catch (e) {}
    var g = grade(), want = g.indexOf(st.usual) + st.feel, k = Math.max(0, Math.min(g.length - 1, want)), size = g[k];
    res.hidden = false;
    res.appendChild(el('h3', '', 'Seu tamanho nesta peça: ' + size));
    var why = 'Você usa ' + st.usual + (st.feel ? ' e gosta ' + (st.feel < 0 ? 'mais justo' : 'mais solto') + ', então ' + (st.feel < 0 ? 'um abaixo' : 'um acima') + '.' : ' e gosta na medida.');
    if (want > k) why += ' O ' + size + ' é o maior tamanho desta peça: fale com a gente antes de escolher.';
    if (want < k) why += ' O ' + size + ' é o menor tamanho desta peça.';
    res.appendChild(el('p', '', why));
    var line = measuresOf(size);
    if (line) res.appendChild(el('p', '', 'Medidas da peça no ' + size + ': ' + line + '.'));
    if (onProductPage()) {
      var b = el('button', 'sv-fit__primary', 'Usar o tamanho ' + size); b.type = 'button';
      b.addEventListener('click', function () { selectSize(size); close(); });
      res.appendChild(b);
    }
    var h = waHref(st.data && st.data.title);
    if (want > k && h) { var a = el('a', 'sv-fit__ghost', 'Conversar sobre meu caimento'); a.href = h; a.target = '_blank'; a.rel = 'noopener'; res.appendChild(a); }
    // era só texto e recebia toque (Clarity 21/10/2026): virou atalho para as outras abas
    var row = el('div', 'sv-fit__actions');
    [['table', 'Ver a tabela'], ['compare', 'Comparar em cm']].forEach(function (x) {
      var t = el('button', 'sv-fit__ghost', x[1]); t.type = 'button'; t.dataset.fitTab = x[0]; row.appendChild(t);
    });
    res.appendChild(row);
  }
  function measuresOf(size) {
    var out = [];
    (st.data.tables || []).forEach(function (t) {
      var row = (t.rows || []).find(function (r) { return String(r[0]).trim().toLowerCase() === size.toLowerCase(); });
      if (!row) return;
      var cells = row.slice(1).map(function (c, i) { return String(c || '').trim() ? (t.cols[i + 1] || '').toLowerCase() + ' ' + c : ''; }).filter(Boolean);
      if (cells.length) out.push((st.data.tables.length > 1 && t.t ? t.t + ': ' : '') + cells.join(' · '));
    });
    return out.join('; ');
  }
  function hasTables() { return !!(st.data && st.data.tables && st.data.tables.length); }
  function setPref(v) {
    st.pref = PREF[v] ? v : 'certo';
    $$('[data-comfort]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.comfort === st.pref)); });
  }
  function renderData() {
    var has = hasTables();
    $('[data-fit-loading]').hidden = true;
    $('[data-fit-missing]').hidden = has;
    var wa = $('[data-fit-wa]'), h = waHref(st.data && st.data.title);
    if (h) { wa.href = h; wa.hidden = false; } else wa.hidden = true;
    $('[data-fit-tablehost]').innerHTML = has ? st.data.html : '';
    if (has) renderUsual();
    $('.sv-fit__tabs').hidden = !has;
    var p = getProfile();
    var f = $('[data-fit-form]');
    f.bust.value = p && p.bust || ''; f.waist.value = p && p.waist || ''; f.hip.value = p && p.hip || '';
    setPref(p ? p.pref : 'certo');
    $('[data-fit-saved]').hidden = !complete(p);
    setTab(st.tab);
    var res = $('[data-fit-result]'); res.hidden = true; res.textContent = '';
    if (has && complete(p)) compute(p, true);
  }

  function readForm() {
    var f = $('[data-fit-form]'), p = { pref: st.pref }, ok = true;
    REG.forEach(function (r) {
      var k = r[0], v = num(f[k].value), e = $('[data-err="' + k + '"]');
      var bad = v == null || v < LIM[k][0] || v > LIM[k][1];
      f[k].setAttribute('aria-invalid', String(bad)); e.textContent = bad ? 'Informe ' + r[1].toLowerCase() + ' em cm (' + LIM[k][0] + ' a ' + LIM[k][1] + ').' : '';
      if (bad) ok = false; else p[k] = v;
    });
    if (!ok) { var first = $$('[aria-invalid="true"]', f)[0]; if (first) first.focus(); }
    return ok ? p : null;
  }

  function compute(p, silent) {
    var res = $('[data-fit-result]'); res.textContent = ''; res.hidden = false;
    // só tamanhos à venda entram na recomendação (a tabela pode trazer PP que o seletor não tem)
    var g = (st.data.sizes || []).map(function (x) { return String(x).trim().toLowerCase(); });
    var results = st.data.tables.map(function (t) {
      var rows = (t.rows || []).filter(function (r) { return !g.length || g.indexOf(String(r[0]).trim().toLowerCase()) > -1; });
      return analyze(rows.length ? Object.assign({}, t, { rows: rows }) : t, p);
    }).filter(Boolean);
    if (!results.length) {
      res.appendChild(el('h3', '', 'Vamos cuidar dessa escolha juntas.'));
      res.appendChild(el('p', '', 'A tabela desta peça não traz busto, cintura ou quadril para comparar. Veja a aba Tabela ou fale com o atendimento.'));
      support(res, p); return;
    }
    var multi = results.length > 1;
    results.forEach(function (r) { res.appendChild(piece(r, p, multi)); });
    var sizes = results.map(function (r) { return r.size; });
    var same = sizes.every(function (s) { return s === sizes[0]; });
    var blocked = results.some(function (r) { return r.extreme || r.conflict; });
    var pick = same && !blocked ? sizes[0] : null;
    var grade = st.data.sizes || [];
    var inGrade = pick && (!grade.length || grade.some(function (g) { return g.toLowerCase() === pick.toLowerCase(); }));
    if (multi && !same) res.appendChild(el('p', '', 'As peças apontam para tamanhos diferentes (' + results.map(function (r) { return (r.name || 'Peça') + ' ' + r.size; }).join(', ') + '). Fale com o atendimento para combinar os tamanhos antes de escolher.'));
    if (pick && !inGrade) res.appendChild(el('p', '', 'O tamanho ' + pick + ' da tabela não aparece na grade à venda desta peça. Fale com o atendimento antes de escolher.'));
    if (pick && inGrade && onProductPage()) {
      var b = el('button', 'sv-fit__primary', 'Usar tamanho ' + pick); b.type = 'button';
      b.addEventListener('click', function () { selectSize(pick); close(); });
      res.appendChild(b);
    }
    support(res, p);
    var ids = sizes;
    $$('.sv-fit-tbl tbody tr').forEach(function (tr) { tr.classList.toggle('is-me', ids.indexOf(tr.dataset.size) > -1); });
    var btn = res.querySelector('.sv-fit__primary'), first = res.querySelector('.sv-fit__piece > p:not(.sv-fit__piece-name)');
    if (btn && first && !multi) first.after(btn);
    if (!silent) res.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }
  function piece(r, p, multi) {
    var box = el('div', 'sv-fit__piece');
    if (multi && r.name) box.appendChild(el('p', 'sv-fit__piece-name', r.name));
    box.appendChild(el('h3', '', r.extreme ? 'Vamos cuidar dessa escolha juntas.' : 'Seu tamanho nesta peça: ' + r.size));
    var tone = PREF[p.pref].label, msg;
    if (r.extreme) msg = 'Compare os valores informados com a tabela de medidas antes de escolher o tamanho.';
    else if (r.conflict) msg = 'Por região: ' + r.regionSizes.join(' · ') + '. Compare as linhas na aba Tabela e, na dúvida, peça orientação ao atendimento.';
    else {
      msg = 'Para um caimento ' + tone + ', o ' + r.size + ' é o menor tamanho que veste bem em todas as regiões.';
      if (r.below && r.tightBelow.length) msg += ' No ' + r.below + ', ' + listPt(r.tightBelow) + (r.tightBelow.length > 1 ? ' ficariam' : ' ficaria') + ' mais ' + (r.base === 'corpo' ? 'apertado' : 'justo') + (r.tightBelow.length > 1 ? 's' : '') + ' que o seu gosto.';
      if (r.near) msg += ' Alguma região com folga maior não impede a escolha: a peça tem movimento.';
    }
    if (r.base === 'peca' && !r.extreme && !r.conflict) msg += ' Folgas calculadas com a medida da peça.';
    box.appendChild(el('p', '', msg));
    var list = el('div', 'sv-fit__regions');
    r.regions.forEach(function (g) {
      var d = el('div', 'sv-fit__region'); d.dataset.state = g.state;
      d.appendChild(el('strong', '', g.label)); d.appendChild(el('span', '', fmt(g.value) + ' cm · tabela ' + g.ref)); d.appendChild(el('small', '', g.text));
      list.appendChild(d);
    });
    box.appendChild(list);
    var ctx = 'A tabela orienta a escolha; tecido, modelagem e movimento também contam.';
    if (p.pref === 'solto' && r.next) ctx += ' Para mais espaço, compare também o ' + r.next + ' na aba Tabela.';
    if (p.pref === 'justo' && r.prev) ctx += ' Para um caimento mais próximo, compare também o ' + r.prev + ' na aba Tabela.';
    box.appendChild(el('p', '', ctx));
    return box;
  }
  function listPt(a) { return a.length < 2 ? a[0] : a.slice(0, -1).join(', ') + ' e ' + a[a.length - 1]; }
  function support(res, p) {
    var row = el('div', 'sv-fit__actions');
    var h = waHref(st.data && st.data.title);
    if (h) { var a = el('a', 'sv-fit__ghost', 'Conversar sobre meu caimento'); a.href = h; a.target = '_blank'; a.rel = 'noopener'; row.appendChild(a); }
    var c = el('button', 'sv-fit__copy', 'Copiar minhas medidas'); c.type = 'button';
    c.addEventListener('click', function () {
      var t = 'Busto ' + fmt(p.bust) + ' cm · Cintura ' + fmt(p.waist) + ' cm · Quadril ' + fmt(p.hip) + ' cm · Prefiro ' + PREF[p.pref].label;
      var done = function () { c.textContent = 'Copiado'; setTimeout(function () { c.textContent = 'Copiar minhas medidas'; }, 2000); };
      try { navigator.clipboard.writeText(t).then(done, function () { c.textContent = 'Não foi possível copiar'; }); } catch (e) { c.textContent = 'Não foi possível copiar'; }
    });
    row.appendChild(c); res.appendChild(row);
  }

  function onProductPage() { return !!dlg.dataset.handle && st.handle === dlg.dataset.handle; }
  function selectSize(size) {
    document.dispatchEvent(new CustomEvent('sv:fit:select', { detail: { size: size, handle: st.handle } }));
    var on = (st.data && st.data.sizeOption || '').toLowerCase(), hit = null;
    $$('input[type="radio"]', document).forEach(function (r) {
      if (hit || r.value.trim().toLowerCase() !== size.toLowerCase() || r.closest('dialog')) return;
      var scope = (r.name + ' ' + ((r.closest('fieldset') || {}).textContent || '')).toLowerCase();
      if (!on || scope.indexOf(on) > -1 || /tam|size/.test(scope)) hit = r;
    });
    if (hit) { hit.click(); return; }
    $$('select', document).forEach(function (s) {
      if (hit || s.closest('dialog')) return;
      Array.prototype.forEach.call(s.options, function (o) { if (!hit && o.value.trim().toLowerCase() === size.toLowerCase()) { s.value = o.value; hit = s; } });
    });
    if (hit && hit.tagName === 'SELECT') hit.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---------- abrir / fechar ---------- */
  function open(detail) {
    detail = detail || {};
    st.trigger = detail.trigger || document.activeElement;
    st.handle = detail.handle || dlg.dataset.handle || null;
    // sv-pdp.js também emite fit:open no mesmo clique: só a 1ª abertura escolhe a aba padrão
    if (detail.tab) st.tab = detail.tab; else if (!dlg.open) st.tab = complete(getProfile()) ? 'compare' : 'usual';
    if (!dlg.open) { dlg.showModal(); if (window.SV && SV.lockScroll) SV.lockScroll(); }
    $('[data-fit-loading]').hidden = false;
    var handle = st.handle;
    load(handle).then(function (d) {
      if (handle !== st.handle) return;
      st.data = d; renderData();
      var first = $('[data-fit-form] input');
      if (first && st.tab === 'compare' && hasTables() && !complete(getProfile()) && !(window.matchMedia && matchMedia('(pointer: coarse)').matches)) first.focus({ preventScroll: true });
    });
    var f = $('[data-fit-form]'); if (!st.data) f.hidden = false;
  }
  function close() { if (dlg.open) dlg.close(); }
  function onClosed() {
    if (window.SV && SV.unlockScroll) SV.unlockScroll();
    var t = st.trigger; st.trigger = null;
    if (t && t.focus && document.contains(t)) try { t.focus({ preventScroll: true }); } catch (e) {}
  }

  function init() {
    dlg = document.getElementById('sv-fit');
    if (!dlg) return;
    dlg.addEventListener('close', onClosed);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    // tocar numa linha da tabela escolhe aquele tamanho (Clarity 20/10/2026: cliques mortos nos valores da tabela)
    dlg.addEventListener('click', function (e) {
      var tr = e.target.closest('[data-fit-tablehost] tbody tr[data-size]');
      if (!tr || tr.hasAttribute('data-off') || !onProductPage()) return;
      selectSize(tr.dataset.size); close();
    });
    dlg.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-fit-close')) close();
      else if (b.dataset.fitTab) setTab(b.dataset.fitTab);
      else if (b.dataset.usual) { st.usual = b.dataset.usual; usualUI(); }
      else if (b.dataset.feel) { st.feel = +b.dataset.feel; usualUI(); }
      else if (b.dataset.comfort) { setPref(b.dataset.comfort); var p = readQuiet(); if (p && !$('[data-fit-result]').hidden) compute(p, true); }
      else if (b.hasAttribute('data-fit-clear')) {
        clearProfile(); var f = $('[data-fit-form]'); f.reset(); setPref('certo'); $('[data-fit-saved]').hidden = true;
        var r = $('[data-fit-result]'); r.hidden = true; r.textContent = ''; $$('.sv-fit-tbl tr.is-me').forEach(function (x) { x.classList.remove('is-me'); });
        f.bust.focus();
      } else if (b.hasAttribute('data-fit-edit')) { setTab('compare'); $('[data-fit-form]').bust.focus(); }
    });
    $('[data-fit-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var p = readForm(); if (!p) return;
      setProfile(p); $('[data-fit-saved]').hidden = false; compute(p, false);
    });
    $('[data-fit-form]').addEventListener('input', function (e) { if (e.target.name) { e.target.removeAttribute('aria-invalid'); $('[data-err="' + e.target.name + '"]').textContent = ''; } });
    document.addEventListener('sv:fit:open', function (e) { open(e.detail); });
    // cliques mortos (Clarity 20/10/2026): o rótulo "Escolha seu tamanho" abre o provador; os chips de especificação
    // levam à explicação (comprimento/tamanho = tabela; o resto = descrição detalhada da peça, com a lupa quando houver)
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var lg = e.target.closest('.sv-opt--size .sv-opt__legend-txt');
      if (lg) { var l = lg.parentNode.querySelector('[data-sv-fit-open]'); if (l) l.click(); return; }
      var f = e.target.closest('.sv-pdp-fact'); if (!f) return;
      var lab = ((f.querySelector('small') || {}).textContent || '').toLowerCase();
      if (/compr|tamanh|medida/.test(lab)) { open({ trigger: f, tab: 'table' }); return; }
      var pd = document.querySelector('.sv-pd [data-sv-pd-lupa]') || document.querySelector('.sv-pd');
      if (!pd) return;
      var sc = (window.SV && SV.scroller) ? SV.scroller() : (document.scrollingElement || document.documentElement);
      var isDoc = sc === document.scrollingElement || sc === document.documentElement;
      sc.scrollTo({ top: Math.max(0, pd.getBoundingClientRect().top + (isDoc ? window.scrollY : sc.scrollTop) - 110), behavior: 'smooth' });
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-sv-fit-open]');
      if (t) { e.preventDefault(); open({ trigger: t, handle: t.dataset.handle, tab: t.dataset.svFitOpen === 'table' ? 'table' : undefined }); }
    });
  }
  function readQuiet() { var f = $('[data-fit-form]'), p = { pref: st.pref }; for (var i = 0; i < REG.length; i++) { var v = num(f[REG[i][0]].value); if (!v) return null; p[REG[i][0]] = v; } return p; }

  window.svFit = { analyze: analyze, parseCell: parseCell };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
